/**
 * PB-29 — First Order LP hero review carousel (Figma 1:1544).
 * Desktop: 4 cards per viewport, page-based arrows. Mobile: single-card scroll snap.
 */
(function () {
  const DESKTOP_QUERY = '(min-width: 750px)';
  const DESKTOP_PER_VIEW = 4;

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function initHeroReviewSlider(zone) {
    const shell = zone.closest('.pb-lp-june-hero__shell');
    const track = zone.querySelector('[data-pb-lp-hero-track]');
    const prev = shell ? shell.querySelector('[data-pb-lp-hero-prev]') : null;
    const next = shell ? shell.querySelector('[data-pb-lp-hero-next]') : null;
    if (!track || !prev || !next) return;

    const slides = () => track.querySelectorAll('.pb-lp-june-hero__reviews-slide');

    function pageWidth() {
      return track.clientWidth;
    }

    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function maxPage() {
      const count = slides().length;
      if (!isDesktop()) {
        return Math.max(0, count - 1);
      }
      return Math.max(0, Math.ceil(count / DESKTOP_PER_VIEW) - 1);
    }

    function scrollLeftForPage(page) {
      const pageIndex = Math.max(0, Math.min(page, maxPage()));
      if (!isDesktop()) {
        const slide = slides()[pageIndex];
        return slide ? slide.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0) : 0;
      }

      if (pageIndex >= maxPage()) {
        return maxScrollLeft();
      }

      return pageIndex * pageWidth();
    }

    function currentPage() {
      const width = pageWidth();
      if (width <= 0) return 0;

      if (!isDesktop()) {
        const sl = track.scrollLeft;
        let nearest = 0;
        let minDistance = Infinity;
        slides().forEach(function (slide, index) {
          const distance = Math.abs(sl - scrollLeftForPage(index));
          if (distance < minDistance) {
            minDistance = distance;
            nearest = index;
          }
        });
        return nearest;
      }

      const sl = track.scrollLeft;
      const lastPage = maxPage();
      if (sl >= maxScrollLeft() - 2) return lastPage;

      return Math.min(lastPage, Math.round(sl / width));
    }

    function goToPage(page, instant) {
      track.scrollTo({
        left: scrollLeftForPage(page),
        behavior: instant ? 'auto' : 'smooth',
      });
    }

    function updateButtons() {
      const page = currentPage();
      const last = maxPage();

      prev.disabled = page <= 0;
      next.disabled = page >= last;
    }

    function snapToNearestPage(instant) {
      goToPage(currentPage(), instant);
    }

    prev.addEventListener('click', function () {
      if (prev.disabled) return;
      goToPage(currentPage() - 1);
    });

    next.addEventListener('click', function () {
      if (next.disabled) return;
      goToPage(currentPage() + 1);
    });

    track.addEventListener('scroll', updateButtons, { passive: true });

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', updateButtons);
    }

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        snapToNearestPage(true);
        updateButtons();
      }, 100);
    });

    snapToNearestPage(true);
    updateButtons();
  }

  function boot() {
    document.querySelectorAll('[data-pb-lp-hero-slider]').forEach(initHeroReviewSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-pb-lp-hero-slider]');
    if (root) initHeroReviewSlider(root);
  });
})();